<script lang="ts">
	interface Props {
		strokeColor?: string;
	}

	let { strokeColor = "black" }: Props = $props();
</script>

<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_624_61)">
		<circle cx="32" cy="17" r="15" stroke={strokeColor} class="svg-stroke" stroke-width="4" />
		<path
			d="M2.5 62C2.5 62 -4 34.5 32 34.5C68 34.5 61.5 62 61.5 62"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
			stroke-linecap="round"
		/>
	</g>
	<defs>
		<clipPath id="clip0_624_61">
			<rect width="64" height="64" fill="white" />
		</clipPath>
	</defs>
</svg>

<style>
</style>
